/**
 * @fileoverview Empty state component for when no messages exist.
 * Provides helpful guidance about how messages are generated.
 */

import { MessageSquare, Phone } from 'lucide-react';

/**
 * Renders a centered empty state with icon and explanatory text.
 * Displayed when no SMS conversations exist for the tenant.
 */
export function MessageEmptyState() {
  return (
    <div className="flex-1 flex items-center justify-center p-8">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6">
          <MessageSquare className="w-8 h-8 text-primary" />
        </div>
        <h2 className="text-xl font-semibold text-foreground mb-2">No messages yet</h2>
        <p className="text-muted-foreground mb-6">
          Messages will appear here when customers reply to missed call texts or when you send
          outbound SMS.
        </p>
        <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
          <Phone className="w-4 h-4" />
          <span>Missed call SMS are sent automatically when enabled</span>
        </div>
      </div>
    </div>
  );
}
